/** README
 *  1- 按需引入eCharts组件
 *  2- 给项目注册 VChart 组件
 * 
 *  使用方式：
 * 
 *  注意事项：
 */

import * as echarts from "echarts/core";
import VChart from "vue-echarts";
import { CanvasRenderer } from "echarts/renderers";
import { PieChart, BarChart, LineChart, PictorialBarChart } from "echarts/charts";
import {
  GridComponent,
  TitleComponent,
  LegendComponent,
  GraphicComponent,
  ToolboxComponent,
  TooltipComponent,
  DataZoomComponent,
  VisualMapComponent
} from "echarts/components";


function install(app) {
  /**
   * 按需引入eCharts组件:
   * >>> https://echarts.apache.org/handbook/zh/basics/import#%E6%8C%89%E9%9C%80%E5%BC%95%E5%85%A5-echarts-%E5%9B%BE%E8%A1%A8%E5%92%8C%E7%BB%84%E4%BB%B6
   */
  const { use } = echarts;
  use([
    PieChart,
    BarChart,
    LineChart,
    PictorialBarChart,
    CanvasRenderer,
    GridComponent,
    TitleComponent,
    LegendComponent,
    GraphicComponent,
    ToolboxComponent,
    TooltipComponent,
    DataZoomComponent,
    VisualMapComponent
  ]);

  /**
   * 注册VChart组件
   * >>> 必须将 `$echarts` 添加到全局 `globalProperties` ，为了配合 https://pure-admin-utils.netlify.app/hooks/useEcharts/useEcharts.html 使用
   */
  app.config.globalProperties.$echarts = echarts;
  app.component("VChart", VChart);
}


export default { install };






